<style>
.space{
  margin-top: 150px;
}
</style>

<Header>Notifications</Header>
<div class="has-header"></div>

<div class="center space">
  <h3>Coming Soon...</h3>
</div>

<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';
export let params = {};

import Auth from "../interfaces/Auth.svelte";
let auth;

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";


</script>